import { render, staticRenderFns } from "./DetectionAreas.vue?vue&type=template&id=50f5c7cd"
import script from "./DetectionAreas.vue?vue&type=script&lang=js"
export * from "./DetectionAreas.vue?vue&type=script&lang=js"
import style0 from "./DetectionAreas.vue?vue&type=style&index=0&id=50f5c7cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports